import { isEmpty } from "lodash";
import React, { FunctionComponent } from "react";
import { FormSubmitStatusText } from "./FormSubmitStatusText.style";
interface IProps {
  error?: string;
}
const ErrorMessage: FunctionComponent<IProps> = ({ error }) => (
  <>
    {isEmpty(error) ? (
      ""
    ) : (
      <FormSubmitStatusText error>{error}</FormSubmitStatusText>
    )}
  </>
);
export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/common/Form/FormSubmitStatusText/ErrorMessage.tsx